import { buildWorkflowCardsPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateWorkflowCards = async ({
  workflow,
  cardTypes,
  stream = true,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const { messages } = buildWorkflowCardsPrompt({ workflow, cardTypes, stream })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      useCase: 'cards',
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'cards',
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
